import { render } from "./BzListRow.vue?vue&type=template&id=52e74f4a&scoped=true"
import script from "./BzListRow.vue?vue&type=script&lang=js"
export * from "./BzListRow.vue?vue&type=script&lang=js"

import "./BzListRow.vue?vue&type=style&index=0&id=52e74f4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e74f4a"]])

export default __exports__